import moment from "moment";
import React from "react";
import { useLoaderData } from "react-router";
import ShowExternalEditApp from "./edit/AppForExternal";
import ShowInternalEditApp from "./edit/AppForInternal";
import { useClient, useCurrentUser } from "common/SessionContext";
import { getInitialExternalShowFormState, getInitialShowFormState } from "shared/utils/fieldsHelper/newShowFields";

export const ShowNewAppForInternal = () => {
  const currentUser = useCurrentUser();
  const client = useClient();
  const viewModel = useLoaderData<server.viewmodel.ShowNewInternalFrontModel>();

  return <ShowInternalEditApp
    exclusivityClause={null}
    ffCategories={viewModel.freeFieldCategories}
    ffPermissions={viewModel.freeFieldPermissions}
    optionsPanel={viewModel.optionsPanel}
    listUrl={viewModel.listUrl}
    statuses={viewModel.statuses}
    itineraryPanel={viewModel.itinerarySidebarPanel}
    hasAccessToAllArtists={viewModel.hasAccessToAllArtists}
    initialValues={getInitialShowFormState(
      client,
      viewModel.defaultProduction,
      viewModel.defaultArtist,
      viewModel.statuses[0],
      currentUser,
      site.userPreference.defaults.publication,
      viewModel.defaultDate ? moment.utc(viewModel.defaultDate) : undefined,
    )}
  />
}

export const ShowNewAppForExternal = () => {
  const viewModel = useLoaderData<server.viewmodel.ShowNewExternalFrontModel>();

  return <ShowExternalEditApp
    ffCategories={viewModel.freeFieldCategories}
    ffPermissions={viewModel.freeFieldPermissions}
    optionsPanel={viewModel.optionsPanel}
    listUrl={viewModel.listUrl}
    statuses={viewModel.statuses}
    initialValues={getInitialExternalShowFormState(
      viewModel.defaultClient,
      viewModel.defaultProduction,
      viewModel.defaultArtist,
      viewModel.statuses[0],
      viewModel.defaultDate ? moment.utc(viewModel.defaultDate) : undefined,
    )}
  />
}
